// Dummy item for the design-system gallery's edit-wizard demo. Not used by any
// real feature; safe to extend when new field types need showcasing.
export default class DemoWizardItem {
  Name = '';
  CategoryId = '';
  Description = '';
  StartDate: string | null = null;
  Budget = '';
}
